module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "id": "app"
    }
  }, [(_vm.checkRoute() && _vm.shouldRoutesBeDisplayed) ? _c('topnavbar', {
    on: {
      "force-update": _vm.forceUpdate,
      "toggle-drawer": _vm.toggleDrawer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkRoute() && !_vm.irAdmin && _vm.shouldRoutesBeDisplayed) ? _c('sidebar', {
    ref: "sidebar",
    attrs: {
      "drawer-open": _vm.isDrawerOpen
    },
    on: {
      "drawer-closed": _vm.handleDrawerClosed
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkRoute() && _vm.irAdmin && _vm.shouldRoutesBeDisplayed) ? _c('iradminsidebar') : _vm._e(), _vm._v(" "), (_vm.shouldRoutesBeDisplayed) ? _c('router-view', {
    ref: "accountSummary"
  }) : _vm._e(), _vm._v(" "), (_vm.maintenance) ? _c('maintenance') : _vm._e(), _vm._v(" "), _c('mfa-phone-preference-dialog', {
    attrs: {
      "visible": _vm.showPhonePreferenceDialog,
      "user": _vm.currentUser
    },
    on: {
      "saved": _vm.handlePhonePreferenceSaved,
      "cancel": _vm.handlePhonePreferenceCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b1757ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2166
// module chunks = 1